import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, FileText, Zap, BookOpen } from 'lucide-react';
export function HeroSection() {
  return <section className="px-4 max-w-5xl mx-auto text-center mt-[-50px] mb-[-50px] space-y-[0px] pt-[10px] pb-[10px]" data-id="element-176">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="inline-flex items-center gap-2 bg-pink-900/30 text-pink-400 px-4 py-1.5 rounded-full font-medium border border-pink-500/20 mt-[0px] mb-[0px] text-[12px]" data-id="element-177">
        <span data-id="element-178">💅</span> TU MANUAL DIGITAL™
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className="md:text-7xl font-extrabold tracking-tight text-balance mt-[-5px] mb-[-5px] text-[20px]" data-id="element-179">
        Cada día con agenda vacía es plata que estás perdiendo
      </motion.h1>

      <motion.h2 initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} className="md:text-6xl font-black text-pink-500 mt-[-5px] mb-[-5px] text-[16px]" data-id="element-180">
        Este sistema te muestra exactamente cómo empezar a llenarla desde esta
        semana
      </motion.h2>

      <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={{
      duration: 0.7,
      delay: 0.25
    }} className="flex flex-col items-center justify-center my-6" data-id="element-181">
        <img src="https://cdn.magicpatterns.com/uploads/6DwSZpNvaURWNiRyvKUwKd/MOCKUP1-removebg-preview.png" alt="Megapack Manicurista Lista - Mockup del producto" className="w-full max-w-xs md:max-w-sm drop-shadow-[0_0_30px_rgba(236,72,153,0.2)] mt-[-60px] mb-[-60px] pt-[40px] pb-[40px]" data-id="element-182" />
        <p className="md:text-2xl text-gray-300 font-medium pt-[5px] pb-[5px] text-[16px]" data-id="element-183">
          El sistema N°1 para manicuristas independientes
        </p>
        <p className="text-gray-400 pt-[0px] pb-[0px] mt-[0px] mb-[0px] text-[12px]" data-id="element-184">
          Scripts · Organización · Finanzas · Todo listo para usar
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="flex flex-nowrap md:gap-3 text-xs md:text-sm font-medium text-gray-300 mt-[0px] mb-[0px] items-center justify-center pt-[4px] pb-[4px] pl-[0px] pr-[0px] gap-[5px]" data-id="element-185">
        <div className="flex items-center bg-gray-800/50 px-2 py-1 rounded-md border border-gray-700 whitespace-nowrap pt-[0px] pb-[0px] pl-[4px] pr-[4px] gap-[0px]" data-id="element-186">
          <FileText size={14} className="text-gray-400" data-id="element-187" /> 100% PDF
        </div>
        <div className="flex items-center bg-gray-800/50 px-2 py-1 rounded-md border border-gray-700 whitespace-nowrap font-[500] pt-[0px] pb-[0px] gap-[0px]" data-id="element-188">
          Acceso inmediato
        </div>

        <div className="flex bg-gray-800/50 px-2 py-1 rounded-md border border-gray-700 whitespace-nowrap pt-[0px] pb-[0px] pl-[0px] pr-[0px] gap-[0px] flex-row items-center" data-id="element-189">
          Aplicable desde el dia 1
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.5
    }} className="flex flex-col items-center" data-id="element-190">
        <a href="#pricing" className="group relative inline-flex px-8 py-5 text-xl font-bold text-black bg-pink-500 rounded-xl overflow-hidden transition-all hover:scale-105 hover:bg-pink-400 shadow-[0_0_40px_rgba(236,72,153,0.4)] animate-pulse-slow w-full max-w-md gap-[0px] items-center justify-center pt-[10px] pb-[10px] pl-[0px] pr-[0px] mt-[0px] mb-[0px]" data-id="element-191">
          <span className="relative z-10 flex pt-[2px] pb-[2px] gap-[10px] items-center justify-center text-[18px]" data-id="element-192">
            → QUIERO CONSEGUIR CLIENTAS AHORA
          </span>
          <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-193" />
        </a>

        <div className="flex flex-wrap justify-center gap-4 mt-6 text-sm text-gray-400" data-id="element-194">
          <span className="flex items-center gap-1.5" data-id="element-195">
            <Shield size={16} className="text-pink-500" data-id="element-196" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-197">
            <Lock size={16} className="text-pink-500" data-id="element-198" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-199">
            <CreditCard size={16} className="text-blue-400" data-id="element-200" /> Mercado Pago
          </span>
        </div>
      </motion.div>
    </section>;
}